import API_BASE_URL from '../Config';

export const getTiposCreditoPaginados = async (token, page = 0, size = 10, search = '') => {
    const url = new URL(`${API_BASE_URL}/tipos-credito/page`);
    url.searchParams.append('page', page);
    url.searchParams.append('size', size);
    if (search) url.searchParams.append('search', search);

    const response = await fetch(url.toString(), {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar tipos de crédito paginados');
    return response.json();
};

export const getTiposCredito = async (token) => {
    const response = await fetch(`${API_BASE_URL}/tipos-credito`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar tipos de crédito');
    return response.json();
};

export const getTipoCreditoById = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/tipos-credito/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar el tipo de crédito');
    return response.json();
};

export const createTipoCredito = async (token, data) => {
    const response = await fetch(`${API_BASE_URL}/tipos-credito`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear tipo de crédito');
    return response.json();
};

export const updateTipoCredito = async (token, id, data) => {
    const response = await fetch(`${API_BASE_URL}/tipos-credito/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar tipo de crédito');
    return response.json();
};

export const deleteTipoCredito = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/tipos-credito/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al eliminar tipo de crédito');
};
